<template>
  <div class="container">
    <div class="row justify-content-center ">
      <div class="col-sm-12 col-md-8 col-lg-5 my-4">
        <div>
          
          <img
            width="300"           
            class="img-fluid mx-auto d-block"

            src="/assets/img/logos/logo_horizontal.png"
          />
        </div>

        <div class="card shadow-sm">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>


